import { render } from "./AgenciesWithAmountFreeSlots.vue?vue&type=template&id=f00cb4f2&scoped=true"
import script from "./AgenciesWithAmountFreeSlots.vue?vue&type=script&lang=js"
export * from "./AgenciesWithAmountFreeSlots.vue?vue&type=script&lang=js"

import "./AgenciesWithAmountFreeSlots.vue?vue&type=style&index=0&id=f00cb4f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00cb4f2"]])

export default __exports__